import Swiper, { Navigation, Pagination } from 'swiper/swiper-bundle';

Swiper.use([Navigation, Pagination]);

export function Carousel() {
    // eslint-disable-next-line no-unused-vars
    var swiper = new Swiper('.carousel.carouselslider', {
        slidesPerView: 1,
        autoplay: {
            delay: 4000
        },
        autoHeight: true,
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        }
    });
}
